import { isApiErrorDto } from "../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../common/errors/isFetchBaseQueryError";

const CANNOT_AWARD_REJECTED_TENDER = "zz_SourcingEventApiErrorCode_CannotAwardRejectedTender";

export const isRejectedTenderRefusal = (e: unknown): boolean =>
  e != null && isFetchBaseQueryError(e) && isApiErrorDto(e.data) && e.data.errorCode === CANNOT_AWARD_REJECTED_TENDER;
